<ng-container *appTranslate="let t">
  @if (!settingsService.isCandidate) {
    @if (sidebarMode) {
      <ui-sidenav-item
        [iconOnly]="iconOnly"
        [label]="translationProposalService.isOn ? t('translationProposal.turnOff') : t('translationProposal.tooltip')"
        icon="icon-[mi--language-translate-5]"
        (clicked)="onClick($event)"
      />
    } @else {
      <new-ui-button
        icon="icon-[mi--language-translate-5]"
        [pTooltip]="
          translationProposalService.isOn ? t('translationProposal.turnOff') : t('translationProposal.tooltip')
        "
        tooltipPosition="left"
        severity="secondary"
        variant="text"
        (onClick)="onClick($event)"
      />
    }
  }
</ng-container>
